/**
 * Generated by orval v8.4.0 🍺
 * Do not edit manually.
 * Medme Marketing PRM API
 * API для автоматизированных маркетинговых рассылок и выгрузок (MedMe PRM).

**Разделы продукта:**
- **Рассылки** — отправка сообщений по сегменту (разово или по расписанию)
- **Выгрузки** — таблица пациентов по сегменту (файл, опционально e-mail с архивом)
- **Отчётность** — журнал запусков и доставки

**Авторизация:** HttpOnly cookie `token` (JWT), как в stats-api. Получение токена — через `GET /auth` stats-api.

**Контекст организации:** API работает с понятием «организация» — всем списком бизнесов, к которым у пользователя есть доступ. Сервер резолвит бизнесы автоматически из JWT-токена; `businessId` в query-параметрах не передаётся. Для операций над конкретным бизнесом (создание задачи, принятие условий) `businessId` передаётся в теле запроса.

 * OpenAPI spec version: 1.0.0
 */

import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	MutationFunction,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseMutationOptions,
	UseMutationResult,
	UseQueryOptions,
	UseQueryResult,
} from "@tanstack/react-query"
import { useMutation, useQuery } from "@tanstack/react-query"
import { customFetch } from "../../custom-marketing-client"
import type {
	DefaultErrorResponse,
	ForbiddenResponse,
	Lead,
	LeadListResponse,
	LeadSummary,
	MarketingLeadsExportLeadsParams,
	MarketingLeadsGetLeadsSummaryParams,
	MarketingLeadsListLeadsParams,
	MarketingLeadsUpdateLeadBody,
	NotFoundResponse,
} from ".././types/marketing"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

export type HTTPStatusCode1xx = 100 | 101 | 102 | 103
export type HTTPStatusCode2xx = 200 | 201 | 202 | 203 | 204 | 205 | 206 | 207
export type HTTPStatusCode3xx = 300 | 301 | 302 | 303 | 304 | 305 | 307 | 308
export type HTTPStatusCode4xx =
	| 400
	| 401
	| 402
	| 403
	| 404
	| 405
	| 406
	| 407
	| 408
	| 409
	| 410
	| 411
	| 412
	| 413
	| 414
	| 415
	| 416
	| 417
	| 418
	| 419
	| 420
	| 421
	| 422
	| 423
	| 424
	| 426
	| 428
	| 429
	| 431
	| 451
export type HTTPStatusCode5xx = 500 | 501 | 502 | 503 | 504 | 505 | 507 | 511
export type HTTPStatusCodes =
	| HTTPStatusCode1xx
	| HTTPStatusCode2xx
	| HTTPStatusCode3xx
	| HTTPStatusCode4xx
	| HTTPStatusCode5xx

/**
 * @summary Список лидов
 */
export type MarketingLeadsListLeadsResponse200 = {
	data: LeadListResponse
	status: 200
}

export type MarketingLeadsListLeadsResponse403 = {
	data: ForbiddenResponse
	status: 403
}

export type MarketingLeadsListLeadsResponseDefault = {
	data: DefaultErrorResponse
	status: Exclude<HTTPStatusCodes, 200 | 403>
}

export type MarketingLeadsListLeadsResponseSuccess =
	MarketingLeadsListLeadsResponse200 & {
		headers: Headers
	}
export type MarketingLeadsListLeadsResponseError = (
	| MarketingLeadsListLeadsResponse403
	| MarketingLeadsListLeadsResponseDefault
) & {
	headers: Headers
}

export type MarketingLeadsListLeadsResponse =
	| MarketingLeadsListLeadsResponseSuccess
	| MarketingLeadsListLeadsResponseError

export const getMarketingLeadsListLeadsUrl = (
	params?: MarketingLeadsListLeadsParams,
) => {
	const normalizedParams = new URLSearchParams()

	Object.entries(params || {}).forEach(([key, value]) => {
		if (value !== undefined) {
			normalizedParams.append(key, value === null ? "null" : value.toString())
		}
	})

	const stringifiedParams = normalizedParams.toString()

	return stringifiedParams.length > 0
		? `/marketing/leads?${stringifiedParams}`
		: `/marketing/leads`
}

export const MarketingLeadsListLeads = async (
	params?: MarketingLeadsListLeadsParams,
	options?: RequestInit,
): Promise<MarketingLeadsListLeadsResponse> => {
	return customFetch<MarketingLeadsListLeadsResponse>(
		getMarketingLeadsListLeadsUrl(params),
		{
			...options,
			method: "GET",
		},
	)
}

export const getMarketingLeadsListLeadsQueryKey = (
	params?: MarketingLeadsListLeadsParams,
) => {
	return [`/marketing/leads`, ...(params ? [params] : [])] as const
}

export const getMarketingLeadsListLeadsQueryOptions = <
	TData = Awaited<ReturnType<typeof MarketingLeadsListLeads>>,
	TError = ForbiddenResponse | DefaultErrorResponse,
>(
	params?: MarketingLeadsListLeadsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof MarketingLeadsListLeads>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof customFetch>
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {}

	const queryKey =
		queryOptions?.queryKey ?? getMarketingLeadsListLeadsQueryKey(params)

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof MarketingLeadsListLeads>>
	> = ({ signal }) =>
		MarketingLeadsListLeads(params, { signal, ...requestOptions })

	return {
		queryKey,
		queryFn,
		refetchOnMount: false,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof MarketingLeadsListLeads>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MarketingLeadsListLeadsQueryResult = NonNullable<
	Awaited<ReturnType<typeof MarketingLeadsListLeads>>
>
export type MarketingLeadsListLeadsQueryError =
	| ForbiddenResponse
	| DefaultErrorResponse

export function useMarketingLeadsListLeads<
	TData = Awaited<ReturnType<typeof MarketingLeadsListLeads>>,
	TError = ForbiddenResponse | DefaultErrorResponse,
>(
	params: undefined | MarketingLeadsListLeadsParams,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof MarketingLeadsListLeads>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof MarketingLeadsListLeads>>,
					TError,
					Awaited<ReturnType<typeof MarketingLeadsListLeads>>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useMarketingLeadsListLeads<
	TData = Awaited<ReturnType<typeof MarketingLeadsListLeads>>,
	TError = ForbiddenResponse | DefaultErrorResponse,
>(
	params?: MarketingLeadsListLeadsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof MarketingLeadsListLeads>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof MarketingLeadsListLeads>>,
					TError,
					Awaited<ReturnType<typeof MarketingLeadsListLeads>>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useMarketingLeadsListLeads<
	TData = Awaited<ReturnType<typeof MarketingLeadsListLeads>>,
	TError = ForbiddenResponse | DefaultErrorResponse,
>(
	params?: MarketingLeadsListLeadsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof MarketingLeadsListLeads>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Список лидов
 */

export function useMarketingLeadsListLeads<
	TData = Awaited<ReturnType<typeof MarketingLeadsListLeads>>,
	TError = ForbiddenResponse | DefaultErrorResponse,
>(
	params?: MarketingLeadsListLeadsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof MarketingLeadsListLeads>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions = getMarketingLeadsListLeadsQueryOptions(params, options)

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> }

	return { ...query, queryKey: queryOptions.queryKey }
}

/**
 * @summary Сводные показатели лидов
 */
export type MarketingLeadsGetLeadsSummaryResponse200 = {
	data: LeadSummary
	status: 200
}

export type MarketingLeadsGetLeadsSummaryResponse403 = {
	data: ForbiddenResponse
	status: 403
}

export type MarketingLeadsGetLeadsSummaryResponseDefault = {
	data: DefaultErrorResponse
	status: Exclude<HTTPStatusCodes, 200 | 403>
}

export type MarketingLeadsGetLeadsSummaryResponseSuccess =
	MarketingLeadsGetLeadsSummaryResponse200 & {
		headers: Headers
	}
export type MarketingLeadsGetLeadsSummaryResponseError = (
	| MarketingLeadsGetLeadsSummaryResponse403
	| MarketingLeadsGetLeadsSummaryResponseDefault
) & {
	headers: Headers
}

export type MarketingLeadsGetLeadsSummaryResponse =
	| MarketingLeadsGetLeadsSummaryResponseSuccess
	| MarketingLeadsGetLeadsSummaryResponseError

export const getMarketingLeadsGetLeadsSummaryUrl = (
	params?: MarketingLeadsGetLeadsSummaryParams,
) => {
	const normalizedParams = new URLSearchParams()

	Object.entries(params || {}).forEach(([key, value]) => {
		if (value !== undefined) {
			normalizedParams.append(key, value === null ? "null" : value.toString())
		}
	})

	const stringifiedParams = normalizedParams.toString()

	return stringifiedParams.length > 0
		? `/marketing/leads/summary?${stringifiedParams}`
		: `/marketing/leads/summary`
}

export const MarketingLeadsGetLeadsSummary = async (
	params?: MarketingLeadsGetLeadsSummaryParams,
	options?: RequestInit,
): Promise<MarketingLeadsGetLeadsSummaryResponse> => {
	return customFetch<MarketingLeadsGetLeadsSummaryResponse>(
		getMarketingLeadsGetLeadsSummaryUrl(params),
		{
			...options,
			method: "GET",
		},
	)
}

export const getMarketingLeadsGetLeadsSummaryQueryKey = (
	params?: MarketingLeadsGetLeadsSummaryParams,
) => {
	return [`/marketing/leads/summary`, ...(params ? [params] : [])] as const
}

export const getMarketingLeadsGetLeadsSummaryQueryOptions = <
	TData = Awaited<ReturnType<typeof MarketingLeadsGetLeadsSummary>>,
	TError = ForbiddenResponse | DefaultErrorResponse,
>(
	params?: MarketingLeadsGetLeadsSummaryParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof MarketingLeadsGetLeadsSummary>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof customFetch>
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {}

	const queryKey =
		queryOptions?.queryKey ?? getMarketingLeadsGetLeadsSummaryQueryKey(params)

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof MarketingLeadsGetLeadsSummary>>
	> = ({ signal }) =>
		MarketingLeadsGetLeadsSummary(params, { signal, ...requestOptions })

	return {
		queryKey,
		queryFn,
		refetchOnMount: false,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof MarketingLeadsGetLeadsSummary>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MarketingLeadsGetLeadsSummaryQueryResult = NonNullable<
	Awaited<ReturnType<typeof MarketingLeadsGetLeadsSummary>>
>
export type MarketingLeadsGetLeadsSummaryQueryError =
	| ForbiddenResponse
	| DefaultErrorResponse

export function useMarketingLeadsGetLeadsSummary<
	TData = Awaited<ReturnType<typeof MarketingLeadsGetLeadsSummary>>,
	TError = ForbiddenResponse | DefaultErrorResponse,
>(
	params: undefined | MarketingLeadsGetLeadsSummaryParams,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof MarketingLeadsGetLeadsSummary>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof MarketingLeadsGetLeadsSummary>>,
					TError,
					Awaited<ReturnType<typeof MarketingLeadsGetLeadsSummary>>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useMarketingLeadsGetLeadsSummary<
	TData = Awaited<ReturnType<typeof MarketingLeadsGetLeadsSummary>>,
	TError = ForbiddenResponse | DefaultErrorResponse,
>(
	params?: MarketingLeadsGetLeadsSummaryParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof MarketingLeadsGetLeadsSummary>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof MarketingLeadsGetLeadsSummary>>,
					TError,
					Awaited<ReturnType<typeof MarketingLeadsGetLeadsSummary>>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useMarketingLeadsGetLeadsSummary<
	TData = Awaited<ReturnType<typeof MarketingLeadsGetLeadsSummary>>,
	TError = ForbiddenResponse | DefaultErrorResponse,
>(
	params?: MarketingLeadsGetLeadsSummaryParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof MarketingLeadsGetLeadsSummary>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Сводные показатели лидов
 */

export function useMarketingLeadsGetLeadsSummary<
	TData = Awaited<ReturnType<typeof MarketingLeadsGetLeadsSummary>>,
	TError = ForbiddenResponse | DefaultErrorResponse,
>(
	params?: MarketingLeadsGetLeadsSummaryParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof MarketingLeadsGetLeadsSummary>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions = getMarketingLeadsGetLeadsSummaryQueryOptions(
		params,
		options,
	)

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> }

	return { ...query, queryKey: queryOptions.queryKey }
}

/**
 * @summary Выгрузить лиды в Excel
 */
export type MarketingLeadsExportLeadsResponse200 = {
	data: Blob
	status: 200
}

export type MarketingLeadsExportLeadsResponse403 = {
	data: ForbiddenResponse
	status: 403
}

export type MarketingLeadsExportLeadsResponseDefault = {
	data: DefaultErrorResponse
	status: Exclude<HTTPStatusCodes, 200 | 403>
}

export type MarketingLeadsExportLeadsResponseSuccess =
	MarketingLeadsExportLeadsResponse200 & {
		headers: Headers
	}
export type MarketingLeadsExportLeadsResponseError = (
	| MarketingLeadsExportLeadsResponse403
	| MarketingLeadsExportLeadsResponseDefault
) & {
	headers: Headers
}

export type MarketingLeadsExportLeadsResponse =
	| MarketingLeadsExportLeadsResponseSuccess
	| MarketingLeadsExportLeadsResponseError

export const getMarketingLeadsExportLeadsUrl = (
	params?: MarketingLeadsExportLeadsParams,
) => {
	const normalizedParams = new URLSearchParams()

	Object.entries(params || {}).forEach(([key, value]) => {
		if (value !== undefined) {
			normalizedParams.append(key, value === null ? "null" : value.toString())
		}
	})

	const stringifiedParams = normalizedParams.toString()

	return stringifiedParams.length > 0
		? `/marketing/leads/export?${stringifiedParams}`
		: `/marketing/leads/export`
}

export const MarketingLeadsExportLeads = async (
	params?: MarketingLeadsExportLeadsParams,
	options?: RequestInit,
): Promise<MarketingLeadsExportLeadsResponse> => {
	return customFetch<MarketingLeadsExportLeadsResponse>(
		getMarketingLeadsExportLeadsUrl(params),
		{
			...options,
			method: "GET",
		},
	)
}

export const getMarketingLeadsExportLeadsQueryKey = (
	params?: MarketingLeadsExportLeadsParams,
) => {
	return [`/marketing/leads/export`, ...(params ? [params] : [])] as const
}

export const getMarketingLeadsExportLeadsQueryOptions = <
	TData = Awaited<ReturnType<typeof MarketingLeadsExportLeads>>,
	TError = ForbiddenResponse | DefaultErrorResponse,
>(
	params?: MarketingLeadsExportLeadsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof MarketingLeadsExportLeads>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof customFetch>
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {}

	const queryKey =
		queryOptions?.queryKey ?? getMarketingLeadsExportLeadsQueryKey(params)

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof MarketingLeadsExportLeads>>
	> = ({ signal }) =>
		MarketingLeadsExportLeads(params, { signal, ...requestOptions })

	return {
		queryKey,
		queryFn,
		refetchOnMount: false,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof MarketingLeadsExportLeads>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MarketingLeadsExportLeadsQueryResult = NonNullable<
	Awaited<ReturnType<typeof MarketingLeadsExportLeads>>
>
export type MarketingLeadsExportLeadsQueryError =
	| ForbiddenResponse
	| DefaultErrorResponse

export function useMarketingLeadsExportLeads<
	TData = Awaited<ReturnType<typeof MarketingLeadsExportLeads>>,
	TError = ForbiddenResponse | DefaultErrorResponse,
>(
	params: undefined | MarketingLeadsExportLeadsParams,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof MarketingLeadsExportLeads>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof MarketingLeadsExportLeads>>,
					TError,
					Awaited<ReturnType<typeof MarketingLeadsExportLeads>>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useMarketingLeadsExportLeads<
	TData = Awaited<ReturnType<typeof MarketingLeadsExportLeads>>,
	TError = ForbiddenResponse | DefaultErrorResponse,
>(
	params?: MarketingLeadsExportLeadsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof MarketingLeadsExportLeads>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof MarketingLeadsExportLeads>>,
					TError,
					Awaited<ReturnType<typeof MarketingLeadsExportLeads>>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useMarketingLeadsExportLeads<
	TData = Awaited<ReturnType<typeof MarketingLeadsExportLeads>>,
	TError = ForbiddenResponse | DefaultErrorResponse,
>(
	params?: MarketingLeadsExportLeadsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof MarketingLeadsExportLeads>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Выгрузить лиды в Excel
 */

export function useMarketingLeadsExportLeads<
	TData = Awaited<ReturnType<typeof MarketingLeadsExportLeads>>,
	TError = ForbiddenResponse | DefaultErrorResponse,
>(
	params?: MarketingLeadsExportLeadsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof MarketingLeadsExportLeads>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions = getMarketingLeadsExportLeadsQueryOptions(params, options)

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> }

	return { ...query, queryKey: queryOptions.queryKey }
}

/**
 * @summary Детали лида
 */
export type MarketingLeadsGetLeadResponse200 = {
	data: Lead
	status: 200
}

export type MarketingLeadsGetLeadResponse403 = {
	data: ForbiddenResponse
	status: 403
}

export type MarketingLeadsGetLeadResponse404 = {
	data: NotFoundResponse
	status: 404
}

export type MarketingLeadsGetLeadResponseDefault = {
	data: DefaultErrorResponse
	status: Exclude<HTTPStatusCodes, 200 | 403 | 404>
}

export type MarketingLeadsGetLeadResponseSuccess =
	MarketingLeadsGetLeadResponse200 & {
		headers: Headers
	}
export type MarketingLeadsGetLeadResponseError = (
	| MarketingLeadsGetLeadResponse403
	| MarketingLeadsGetLeadResponse404
	| MarketingLeadsGetLeadResponseDefault
) & {
	headers: Headers
}

export type MarketingLeadsGetLeadResponse =
	| MarketingLeadsGetLeadResponseSuccess
	| MarketingLeadsGetLeadResponseError

export const getMarketingLeadsGetLeadUrl = (leadId: string) => {
	return `/marketing/leads/${leadId}`
}

export const MarketingLeadsGetLead = async (
	leadId: string,
	options?: RequestInit,
): Promise<MarketingLeadsGetLeadResponse> => {
	return customFetch<MarketingLeadsGetLeadResponse>(
		getMarketingLeadsGetLeadUrl(leadId),
		{
			...options,
			method: "GET",
		},
	)
}

export const getMarketingLeadsGetLeadQueryKey = (leadId: string) => {
	return [`/marketing/leads/${leadId}`] as const
}

export const getMarketingLeadsGetLeadQueryOptions = <
	TData = Awaited<ReturnType<typeof MarketingLeadsGetLead>>,
	TError = ForbiddenResponse | NotFoundResponse | DefaultErrorResponse,
>(
	leadId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof MarketingLeadsGetLead>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof customFetch>
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {}

	const queryKey =
		queryOptions?.queryKey ?? getMarketingLeadsGetLeadQueryKey(leadId)

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof MarketingLeadsGetLead>>
	> = ({ signal }) =>
		MarketingLeadsGetLead(leadId, { signal, ...requestOptions })

	return {
		queryKey,
		queryFn,
		enabled: !!leadId,
		refetchOnMount: false,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof MarketingLeadsGetLead>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MarketingLeadsGetLeadQueryResult = NonNullable<
	Awaited<ReturnType<typeof MarketingLeadsGetLead>>
>
export type MarketingLeadsGetLeadQueryError =
	| ForbiddenResponse
	| NotFoundResponse
	| DefaultErrorResponse

export function useMarketingLeadsGetLead<
	TData = Awaited<ReturnType<typeof MarketingLeadsGetLead>>,
	TError = ForbiddenResponse | NotFoundResponse | DefaultErrorResponse,
>(
	leadId: string,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof MarketingLeadsGetLead>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof MarketingLeadsGetLead>>,
					TError,
					Awaited<ReturnType<typeof MarketingLeadsGetLead>>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useMarketingLeadsGetLead<
	TData = Awaited<ReturnType<typeof MarketingLeadsGetLead>>,
	TError = ForbiddenResponse | NotFoundResponse | DefaultErrorResponse,
>(
	leadId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof MarketingLeadsGetLead>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof MarketingLeadsGetLead>>,
					TError,
					Awaited<ReturnType<typeof MarketingLeadsGetLead>>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useMarketingLeadsGetLead<
	TData = Awaited<ReturnType<typeof MarketingLeadsGetLead>>,
	TError = ForbiddenResponse | NotFoundResponse | DefaultErrorResponse,
>(
	leadId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof MarketingLeadsGetLead>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Детали лида
 */

export function useMarketingLeadsGetLead<
	TData = Awaited<ReturnType<typeof MarketingLeadsGetLead>>,
	TError = ForbiddenResponse | NotFoundResponse | DefaultErrorResponse,
>(
	leadId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof MarketingLeadsGetLead>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions = getMarketingLeadsGetLeadQueryOptions(leadId, options)

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> }

	return { ...query, queryKey: queryOptions.queryKey }
}

/**
 * @summary Изменить статус и комментарий
 */
export type MarketingLeadsUpdateLeadResponse200 = {
	data: Lead
	status: 200
}

export type MarketingLeadsUpdateLeadResponse403 = {
	data: ForbiddenResponse
	status: 403
}

export type MarketingLeadsUpdateLeadResponse404 = {
	data: NotFoundResponse
	status: 404
}

export type MarketingLeadsUpdateLeadResponseDefault = {
	data: DefaultErrorResponse
	status: Exclude<HTTPStatusCodes, 200 | 403 | 404>
}

export type MarketingLeadsUpdateLeadResponseSuccess =
	MarketingLeadsUpdateLeadResponse200 & {
		headers: Headers
	}
export type MarketingLeadsUpdateLeadResponseError = (
	| MarketingLeadsUpdateLeadResponse403
	| MarketingLeadsUpdateLeadResponse404
	| MarketingLeadsUpdateLeadResponseDefault
) & {
	headers: Headers
}

export type MarketingLeadsUpdateLeadResponse =
	| MarketingLeadsUpdateLeadResponseSuccess
	| MarketingLeadsUpdateLeadResponseError

export const getMarketingLeadsUpdateLeadUrl = (leadId: string) => {
	return `/marketing/leads/${leadId}`
}

export const MarketingLeadsUpdateLead = async (
	leadId: string,
	marketingLeadsUpdateLeadBody: MarketingLeadsUpdateLeadBody,
	options?: RequestInit,
): Promise<MarketingLeadsUpdateLeadResponse> => {
	return customFetch<MarketingLeadsUpdateLeadResponse>(
		getMarketingLeadsUpdateLeadUrl(leadId),
		{
			...options,
			method: "PATCH",
			headers: { "Content-Type": "application/json", ...options?.headers },
			body: JSON.stringify(marketingLeadsUpdateLeadBody),
		},
	)
}

export const getMarketingLeadsUpdateLeadMutationOptions = <
	TError = ForbiddenResponse | NotFoundResponse | DefaultErrorResponse,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof MarketingLeadsUpdateLead>>,
		TError,
		{ leadId: string; data: MarketingLeadsUpdateLeadBody },
		TContext
	>
	request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
	Awaited<ReturnType<typeof MarketingLeadsUpdateLead>>,
	TError,
	{ leadId: string; data: MarketingLeadsUpdateLeadBody },
	TContext
> => {
	const mutationKey = ["marketingLeadsUpdateLead"]
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined }

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof MarketingLeadsUpdateLead>>,
		{ leadId: string; data: MarketingLeadsUpdateLeadBody }
	> = (props) => {
		const { leadId, data } = props ?? {}

		return MarketingLeadsUpdateLead(leadId, data, requestOptions)
	}

	return { mutationFn, ...mutationOptions }
}

export type MarketingLeadsUpdateLeadMutationResult = NonNullable<
	Awaited<ReturnType<typeof MarketingLeadsUpdateLead>>
>
export type MarketingLeadsUpdateLeadMutationBody = MarketingLeadsUpdateLeadBody
export type MarketingLeadsUpdateLeadMutationError =
	| ForbiddenResponse
	| NotFoundResponse
	| DefaultErrorResponse

/**
 * @summary Изменить статус и комментарий
 */
export const useMarketingLeadsUpdateLead = <
	TError = ForbiddenResponse | NotFoundResponse | DefaultErrorResponse,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof MarketingLeadsUpdateLead>>,
			TError,
			{ leadId: string; data: MarketingLeadsUpdateLeadBody },
			TContext
		>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof MarketingLeadsUpdateLead>>,
	TError,
	{ leadId: string; data: MarketingLeadsUpdateLeadBody },
	TContext
> => {
	return useMutation(
		getMarketingLeadsUpdateLeadMutationOptions(options),
		queryClient,
	)
}
